export const MENU_NEED_UPDATE = 'orgs/menu/MENU_NEED_UPDATE';

export const menuNeedUpdate = payload => ({
  type: MENU_NEED_UPDATE,
  payload,
});
